//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
/** Services Import */
/** Components */
import { SAP_BASIC } from './index';
import { Loading } from '../../../../Components/MUIs';
import dayjs from 'dayjs';
import Commons from '../../../../Services/Common/Common';
import { useSelector } from 'react-redux';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
import useDateRange from '../../../../hooks/useDateRange';
//#endregion

function SAP_BASICF() {
  //#region 변수
  const navigate = useNavigate();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);

  const [loading, setLoading] = useState(false);
  const [value, setValue] = React.useState(0);

  const [filterClick1, setFilterClick1] = useState(false); // 1번탭 버튼 이벤트
  const [searchClick1, setSearchClick1] = useState(false);
  const [addClick1, setAddClick1] = useState(false);
  const [saveClick1, setSaveClick1] = useState(false);
  const [deleteClick1, setDeleteClick1] = useState(false);
  const [printClick1, setPrintClick1] = useState(false);
  const [listClick1, setListClick1] = useState(false);

  const [filterClick2, setFilterClick2] = useState(false); // 2번탭 버튼 이벤트
  const [searchClick2, setSearchClick2] = useState(false);
  const [addClick2, setAddClick2] = useState(false);
  const [saveClick2, setSaveClick2] = useState(false);
  const [deleteClick2, setDeleteClick2] = useState(false);
  const [printClick2, setPrintClick2] = useState(false);
  const [listClick2, setListClick2] = useState(false);

  const [filterClick3, setFilterClick3] = useState(false); // 3번탭 버튼 이벤트
  const [searchClick3, setSearchClick3] = useState(false);
  const [addClick3, setAddClick3] = useState(false);
  const [saveClick3, setSaveClick3] = useState(false);
  const [deleteClick3, setDeleteClick3] = useState(false);
  const [printClick3, setPrintClick3] = useState(false);
  const [listClick3, setListClick3] = useState(false);

  const [filterClick4, setFilterClick4] = useState(false); // 4번탭 버튼 이벤트
  const [searchClick4, setSearchClick4] = useState(false);
  const [addClick4, setAddClick4] = useState(false);
  const [saveClick4, setSaveClick4] = useState(false);
  const [deleteClick4, setDeleteClick4] = useState(false);
  const [printClick4, setPrintClick4] = useState(false);
  const [listClick4, setListClick4] = useState(false);

  const [filterClick5, setFilterClick5] = useState(false); // 5번탭 버튼 이벤트
  const [searchClick5, setSearchClick5] = useState(false);
  const [addClick5, setAddClick5] = useState(false);
  const [saveClick5, setSaveClick5] = useState(false);
  const [deleteClick5, setDeleteClick5] = useState(false);
  const [printClick5, setPrintClick5] = useState(false);
  const [listClick5, setListClick5] = useState(false);

  const [filterClick6, setFilterClick6] = useState(false); // 6번탭 버튼 이벤트
  const [searchClick6, setSearchClick6] = useState(false);
  const [addClick6, setAddClick6] = useState(false);
  const [saveClick6, setSaveClick6] = useState(false);
  const [deleteClick6, setDeleteClick6] = useState(false);
  const [printClick6, setPrintClick6] = useState(false);
  const [listClick6, setListClick6] = useState(false);

  const [filterClick7, setFilterClick7] = useState(false); // 7번탭 버튼 이벤트
  const [searchClick7, setSearchClick7] = useState(false);
  const [addClick7, setAddClick7] = useState(false);
  const [saveClick7, setSaveClick7] = useState(false);
  const [deleteClick7, setDeleteClick7] = useState(false);
  const [printClick7, setPrintClick7] = useState(false);
  const [listClick7, setListClick7] = useState(false);

  const searchRef = useRef({
    startDate: dayjs().subtract(3, 'year').format('YYYY-MM-DD'),
    endDate: dayjs().format('YYYY-MM-DD'),
    coList: [],
    coCd: '',
    custList: [],
    custCd: '',
    searchText: '',
  }); //조회조건 조회일자

  // 회사/거래처 선택 상태 관리 및 필수 여부 검증을 위한 Hook
  const { handleCoChange, handleCustChange, validateSelection } =
    useCompanyCustDep({ searchRef, requireCompany: true, requireCust: true });

  // 검색 조건에서 사용할 시작일/종료일 상태 관리 Hook
  const { startDate, endDate, handleStartDateChange, handleEndDateChange } =
    useDateRange(searchRef);
  //#endregion

  useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    await setSearchClick1(true);
  };

  // 관리감독자 이동 클릭 이벤트
  const HandleChange = (event, newValue) => {
    if (newValue === 0) setSearchClick1(true);
    else if (newValue === 1) setSearchClick2(true);
    else if (newValue === 2) setSearchClick3(true);
    else if (newValue === 3) setSearchClick4(true);
    else if (newValue === 4) setSearchClick5(true);
    else if (newValue === 5) setSearchClick6(true);
    else if (newValue === 6) setSearchClick7(true);
    setValue(newValue);
  };
  const deletePayload1 = (item) => ({
    procedureName: 'SP_SAP_FILE_D1',
    _CHAEBUN: Commons.EncryptAES(item.CHAEBUN) || '',
  });
  const searchPayload1 = (item) => ({
    procedureName: 'SP_SAP_FILE_R1',
    _CUST_CD: Commons.EncryptAES(searchRef.current.custCd) || '', //사업장코드
    _START_DATE: Commons.EncryptAES(searchRef.current.startDate) || '', //조회일자(시작)
    _END_DATE: Commons.EncryptAES(searchRef.current.endDate) || '', //조회일자(끝)
    _SEARCH_TEXT: Commons.EncryptAES(searchRef.current.searchText) || '', //검색창
  });
  const savePayload1 = (item) => ({
    procedureName: 'SP_SAP_FILE_U1',
    _CHAEBUN: Commons.EncryptAES(item.CHAEBUN) || '', // 채번
    _CUST_CD: Commons.EncryptAES(searchRef.current.custCd) || '', // 사업장코드
    _DATE: Commons.EncryptAES(dayjs(item.DATE).format('YYYY-MM-DD')) || '', // 작성일자
    _FILE_NAME: Commons.EncryptAES(item.FILE_NAME) || '', // 파일명(사용자가 올린 이름)
    _SAVE_NAME: Commons.EncryptAES(item.SAVE_NAME) || '', // 파일명(저장된 이름)
    _FILE_PATH:
      Commons.EncryptAES(
        `Business/${searchRef.current.custCd}/SAP_FILE/${item.SAVE_NAME}`
      ) || '', //파일경로
    _USER_ID: userInfo.userid || '', // 사용자 아이디
  });
  //#endregion

  return (
    <div className="wrap">
      <SAP_BASIC
        navigate={navigate}
        userInfo={userInfo}
        lanInfo={lanInfo}
        value={value}
        setValue={setValue}
        filterClick1={filterClick1}
        setFilterClick1={setFilterClick1}
        searchClick1={searchClick1}
        setSearchClick1={setSearchClick1}
        addClick1={addClick1}
        setAddClick1={setAddClick1}
        saveClick1={saveClick1}
        setSaveClick1={setSaveClick1}
        deleteClick1={deleteClick1}
        setDeleteClick1={setDeleteClick1}
        printClick1={printClick1}
        setPrintClick1={setPrintClick1}
        listClick1={listClick1}
        setListClick1={setListClick1}
        filterClick2={filterClick2}
        setFilterClick2={setFilterClick2}
        searchClick2={searchClick2}
        setSearchClick2={setSearchClick2}
        addClick2={addClick2}
        setAddClick2={setAddClick2}
        saveClick2={saveClick2}
        setSaveClick2={setSaveClick2}
        deleteClick2={deleteClick2}
        setDeleteClick2={setDeleteClick2}
        printClick2={printClick2}
        setPrintClick2={setPrintClick2}
        listClick2={listClick2}
        setListClick2={setListClick2}
        filterClick3={filterClick3}
        setFilterClick3={setFilterClick3}
        searchClick3={searchClick3}
        setSearchClick3={setSearchClick3}
        addClick3={addClick3}
        setAddClick3={setAddClick3}
        saveClick3={saveClick3}
        setSaveClick3={setSaveClick3}
        deleteClick3={deleteClick3}
        setDeleteClick3={setDeleteClick3}
        printClick3={printClick3}
        setPrintClick3={setPrintClick3}
        listClick3={listClick3}
        setListClick3={setListClick3}
        filterClick4={filterClick4}
        setFilterClick4={setFilterClick4}
        searchClick4={searchClick4}
        setSearchClick4={setSearchClick4}
        addClick4={addClick4}
        setAddClick4={setAddClick4}
        saveClick4={saveClick4}
        setSaveClick4={setSaveClick4}
        deleteClick4={deleteClick4}
        setDeleteClick4={setDeleteClick4}
        printClick4={printClick4}
        setPrintClick4={setPrintClick4}
        listClick4={listClick4}
        setListClick4={setListClick4}
        filterClick5={filterClick5}
        setFilterClick5={setFilterClick5}
        searchClick5={searchClick5}
        setSearchClick5={setSearchClick5}
        addClick5={addClick5}
        setAddClick5={setAddClick5}
        saveClick5={saveClick5}
        setSaveClick5={setSaveClick5}
        deleteClick5={deleteClick5}
        setDeleteClick5={setDeleteClick5}
        printClick5={printClick5}
        setPrintClick5={setPrintClick5}
        listClick5={listClick5}
        setListClick5={setListClick5}
        filterClick6={filterClick6}
        setFilterClick6={setFilterClick6}
        searchClick6={searchClick6}
        setSearchClick6={setSearchClick6}
        addClick6={addClick6}
        setAddClick6={setAddClick6}
        saveClick6={saveClick6}
        setSaveClick6={setSaveClick6}
        deleteClick6={deleteClick6}
        setDeleteClick6={setDeleteClick6}
        printClick6={printClick6}
        setPrintClick6={setPrintClick6}
        listClick6={listClick6}
        setListClick6={setListClick6}
        filterClick7={filterClick7}
        setFilterClick7={setFilterClick7}
        searchClick7={searchClick7}
        setSearchClick7={setSearchClick7}
        addClick7={addClick7}
        setAddClick7={setAddClick7}
        saveClick7={saveClick7}
        setSaveClick7={setSaveClick7}
        deleteClick7={deleteClick7}
        setDeleteClick7={setDeleteClick7}
        printClick7={printClick7}
        setPrintClick7={setPrintClick7}
        listClick7={listClick7}
        setListClick7={setListClick7}
        searchRef={searchRef}
        deletePayload1={deletePayload1}
        searchPayload1={searchPayload1}
        savePayload1={savePayload1}
        searchInfo={searchInfo}
        // 회사, 사업장 관련 props
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        validateSelection={validateSelection}
        // 날짜 관련 props
        startDate={startDate}
        endDate={endDate}
        handleStartDateChange={handleStartDateChange}
        handleEndDateChange={handleEndDateChange}
        // 함수
        HandleChange={HandleChange}
      />
      <Loading open={loading} />
    </div>
  );
}

export default SAP_BASICF;
